export default __webpack_public_path__ + "static/media/jnj-logo.7da1345c.png";